import { render } from "./ImageInpainting.vue?vue&type=template&id=1fcf8fb0&scoped=true"
import script from "./ImageInpainting.vue?vue&type=script&lang=js"
export * from "./ImageInpainting.vue?vue&type=script&lang=js"

import "./ImageInpainting.vue?vue&type=style&index=0&id=1fcf8fb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fcf8fb0"]])

export default __exports__